/* Package JSON Import will be here */
import React, { Component, createRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _, { cloneDeep, isEqual } from 'lodash';
/* Package JSON Import will be here */

/* Project Import will be here */
import { ApiUrls } from '../../../services/api';
import Api from '../../../services/api/serviceCall';
import { Constants } from '../../../config/appConstants';
import * as utility from '../../../services/utility';
import { MessageBox } from '../../sharedComponent/messageBox';
import TmVoucherDataEntryComponent from './TMVoucherDataEntry.Component';
import * as actions from '../../../actions/tmVoucher.Action';
/* Project Import will be here */

class TmVoucherDataEntry extends Component {
    constructor(props) {
        super(props);
        const routeParams = this.props.history.location.state;
        this.state = {
            tmVoucherList: this.emptyTMVoucher(),
            initialTMVoucherList: this.emptyTMVoucher(),
            equipmentOptions: [],
            materialOptions: [],
            isShowImageViewer: false,
            selectedAttachment: '',
            isShowTMVoucherConfirmation: false,
            selectedTMVoucher: {},
            selectedDate: '',
            isSaveButtonDisabled: false,
            goToReportPage: routeParams?.goToReportPage ?? false,
            isProjectUnAssigned: routeParams?.isProjectUnAssigned ?? false,
            isShowLoader: false,
            selectedIndexForDelete: '',
            selectedObjectForDelete: '',
            deleteConfirmationHeader: '',
            deleteConformationMessage: '',
            isDeleteConfirmationPopupVisible: false,
            signatureRef: createRef(),
            isAllowTMVoucherSignature: false,
            isShowTMVoucherSignatureValidation: false
        };
    };

    componentDidMount() {
  
    const { goToReportPage, isProjectUnAssigned } = this.state;
    const selectedTMVoucher = this?.props?.tmVoucherReducer?.selectedTMVoucher ?? "";

    if (!selectedTMVoucher) {
        this.props.history.push("/TimeCard");
        return;
    }

    if (isProjectUnAssigned) {
        this.props.history.push("/TimeCard", { isOpenSelectTaskCode: true });
    }
    if (goToReportPage) {
        this.props.history.push("/TMVoucherPDFViewer", { selectedTMVoucher });
    }

    this.setState({
        selectedTMVoucher: selectedTMVoucher,
        selectedDate: this.props.date.selectedDate
    }, () => {
        this.getEquipmentList();
        this.loadSavedTMVoucher();
        this.getMaterialList();
    });
}

    emptyTMVoucher() {
        return {
            id: 0,
            projectId: "",
            projectNumber: "",
            projectName: "",
            taskCodeID: "",
            taskNumber: "",
            taskName: "",
            descriptionOfWork: "",
            approvedBy: "",
            tmEquipments: [this.emptyEquipment()],
            tmMaterials: [this.emptyMaterial()],
            tmMiscellaneous: [this.emptyTMMiscellaneous()],
            tmEmployees: [],
            tmAttachments: [],
            isDeleted: false,
            hasSignature: false,
            tmVoucherSignature: this.emptyAttachment()
        };
    }

    emptyEquipment() {
        return {
            id: 0,
            equipmentUnitNumber: '',
            equipmentHours: '',
            equipmentDays: '',
            equipmentDescription: '',
            equipmentValue: '',
            equipmentListId: null,
            isDeleted: false
        };
    }

    emptyMaterial() {
        return {
            id: 0,
            materialQuantity: '',
            materialSize: '',
            materialDescription: '',
            materialValue: '',
            materialListId: null,
            isDeleted: false
        };
    }

    emptyTMMiscellaneous() {
        return {
            id: 0,
            miscType: '',
            miscDescription: '',
            isDeleted: false
        };
    }

    emptyAttachment() {
        return {
            id: 0,
            attachmentName: "",
            attachmentType: "",
            attachmentContent: "",
            isActive: "",
            discriminator: Constants.TM_VOUCHER_SIGNATURE_DISCRIMINATOR,
        }
    }

    getEquipmentList() {
        let requestData = {};
        let url = `${ApiUrls.Routes.EQMT_C}${ApiUrls.Routes.GT_EQMT_LT_M}`;
        Api.Post(url, requestData, this, false).then((response) => {
            if (response.success && response.data) {
                let equipmentList = response.data.sort((a, b) => a.displayText - b.displayText).map((a) => {
                    return {
                        key: a.id,
                        text: a.displayText,
                        value: a.displayText,
                        equipmentid: a.id,
                        equipmentdescription: a.displayText,
                    };
                });
                let emptyEquipment = { key: null, text: '-Select Description-', value: '-Select Description-', equipmentdescription: '-Select Description-', equipmentid: null };
                this.setState({ equipmentOptions: [emptyEquipment, ...equipmentList] });
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    getMaterialList() {
        let requestData = {};
        let url = `${ApiUrls.Routes.MATE_C}${ApiUrls.Routes.GT_MATE_LT_M}`;
        Api.Post(url, requestData, this, false).then((response) => {
            if (response.success && response.data) {
                let materialList = response.data.sort((a, b) => a.displayText - b.displayText).map((a) => {
                    return {
                        key: a.id,
                        text: a.displayText,
                        value: a.displayText,
                        materialId: a.id,
                        materialDescription: a.displayText,
                        searchText: a.displayText
                    };
                });
                let emptyMaterial = { key: null, text: '-Select Description-', value: '-Select Description-', materialDescription: '-Select Description-', materialId: null, searchText: '' };
                this.setState({ materialOptions: [emptyMaterial, ...materialList] });
            } else {
                MessageBox(response.message, Constants.ERROR);
            }
        });
    }

    onClickAddTmEquipment() {
        const { tmVoucherList } = this.state;
        tmVoucherList.tmEquipments.push(this.emptyEquipment());
        this.setState({ tmVoucherList });
    }

    onClickAddTMMaterial() {
        const { tmVoucherList } = this.state;
        tmVoucherList.tmMaterials.push(this.emptyMaterial());
        this.setState({ tmVoucherList });
    }

    onClickAddTMMiscellaneous() {
        const { tmVoucherList } = this.state;
        tmVoucherList.tmMiscellaneous.push(this.emptyTMMiscellaneous());
        this.setState({ tmVoucherList });
    }

    getHoursValue(e) {
        e = e.trim();
        let hourValue = e === '.' ? e : isNaN(e) ? "" : e;
        let hour = (typeof (hourValue) === "string" && hourValue.replace(/[^\d\.*]+/g, '')) ? hourValue.replace(/[^\d\.*]+/g, '') : "";
        hour = hour != 0 ? hour.replace(/^0+/, '') : hour == '0.' ? hour : '0';
        return hour;
    }

    handleInputChange(event, index, inputName) {
        const { tmVoucherList, equipmentOptions, materialOptions } = this.state;
        switch (inputName) {
            case Constants.DESCRIPTION_OF_WORK:
                tmVoucherList.descriptionOfWork = event;
                break;
            case Constants.APPROVED_BY:
                tmVoucherList.approvedBy = event;
                break;
            case Constants.EQUIPMENT_UNIT:
                tmVoucherList.tmEquipments[index].equipmentUnitNumber = event;
                break;
            case Constants.EQUIPMENT_HOURS:
                if (Constants.HOURS_REGEX.test(event)) {
                    event = event ? this.getHoursValue(event) : "";
                    tmVoucherList.tmEquipments[index].equipmentHours = event;
                }
                break;
            case Constants.EQUIPMENT_DAYS:
                if (Constants.HOURS_REGEX.test(event)) {
                    event = event ? this.getHoursValue(event) : "";
                    tmVoucherList.tmEquipments[index].equipmentDays = event;
                }
                break;
            case Constants.EQUIPMENT_DROPDOWN:
                const equipmentOption = equipmentOptions.find((a) => a.value === event);
                if ((equipmentOption.equipmentid === null && equipmentOption.equipmentdescription === '-Select Description-') || equipmentOption.equipmentdescription === Constants.OTHER) {
                    tmVoucherList.tmEquipments[index].equipmentDescription = '';
                    tmVoucherList.tmEquipments[index].equipmentValue = equipmentOption.equipmentdescription === Constants.OTHER ? equipmentOption.equipmentdescription : '';
                } else {
                    tmVoucherList.tmEquipments[index].equipmentListId = equipmentOption.equipmentid;
                    tmVoucherList.tmEquipments[index].equipmentDescription = equipmentOption.equipmentdescription;
                    tmVoucherList.tmEquipments[index].equipmentValue = equipmentOption.equipmentdescription;
                }
                break;
            case Constants.EQUIPMENT_DESCRIPTION:
                tmVoucherList.tmEquipments[index].equipmentDescription = event;
                break;
            case Constants.MATERIAL_QUANTITY:
                if (Constants.UNIT_AND_QTY_REGEX.test(event) || event === "") {
                    event = event ? this.getHoursValue(event) : "";
                    tmVoucherList.tmMaterials[index].materialQuantity = event;
                }
                break;
            case Constants.MATERIAL_SIZE:
                tmVoucherList.tmMaterials[index].materialSize = event;
                break;
            case Constants.MATERIAL_DESCRIPTION:
                tmVoucherList.tmMaterials[index].materialDescription = event;
                break;
            case Constants.MATERIAL_DROPDOWN:
                const materialOption = materialOptions.find((a) => a.value === event);
                if ((materialOption.materialId === null && materialOption.materialDescription === '-Select Description-') || materialOption.materialDescription === Constants.OTHER) {
                    tmVoucherList.tmMaterials[index].materialDescription = '';
                    tmVoucherList.tmMaterials[index].materialValue = materialOption.materialDescription === Constants.OTHER ? materialOption.materialDescription : '';
                } else {
                    tmVoucherList.tmMaterials[index].materialListId = materialOption.materialId;
                    tmVoucherList.tmMaterials[index].materialDescription = materialOption.materialDescription;
                    tmVoucherList.tmMaterials[index].materialValue = materialOption.materialDescription;
                }
                break;
            case Constants.TM_MISCELLANEOUS_TYPE:
                tmVoucherList.tmMiscellaneous[index].miscType = event;
                break;
            case Constants.TM_MISCELLANEOUS_DESCRIPTION:
                tmVoucherList.tmMiscellaneous[index].miscDescription = event;
                break;
            default:
                break;
        }
        this.setState({ tmVoucherList })
    }

    onClickDeleteConfirmation() {
        const { tmVoucherList, selectedIndexForDelete, selectedObjectForDelete } = this.state;
        const index = selectedIndexForDelete;
        const objName = selectedObjectForDelete;
        if (tmVoucherList[objName][index].id === 0) {
            tmVoucherList[objName].splice(index, 1);
        } else {
            tmVoucherList[objName][index].isDeleted = true;
        }
        this.setState({ tmVoucherList, isDeleteConfirmationPopupVisible: false });
    }

    selectFiles(images) {
        const { tmVoucherList } = this.state;
        this.setState({ isSaveButtonDisabled: true }, () => {
            const attachments = tmVoucherList?.tmAttachments ?? [];
            utility.maximumImageCheck(attachments, images, true, true).then((data) => {
                if (data.success) {
                    tmVoucherList["tmAttachments"] = attachments;
                    this.setState({ tmVoucherList, isSaveButtonDisabled: false });
                }
                else {
                    this.setState({ isSaveButtonDisabled: false });
                }
            });
        });
    }

    viewOrCloseAttachment(isOpen = false, attachment = {}) {
        this.setState({ isShowImageViewer: isOpen, selectedAttachment: attachment });
    }

    removeAttachment(attachmentIndex) {
        const { tmVoucherList } = this.state;
        if (tmVoucherList.tmAttachments[attachmentIndex].id === 0) {
            tmVoucherList.tmAttachments.splice(attachmentIndex, 1);
        } else {
            tmVoucherList.tmAttachments[attachmentIndex].isActive = false;
        }
        this.setState({ tmVoucherList });
    }

    loadSavedTMVoucher() {
        const { selectedTMVoucher } = this.state;
        let url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.GT_SLCT_TM_VCHR_DET_M}?deviceId=${this.props.device.deviceId}&projectId=${selectedTMVoucher.projectId}&taskCodeId=${selectedTMVoucher.taskCodeID}&tmVoucherId=${selectedTMVoucher.id}`;
        Api.Get(url, this).then((response) => {
            if (!response.data) {
                this.props.history.push("/Timecard");
            } else {
                const tmVoucherList = response.data;
                const tmVoucherStatus = tmVoucherList.status;
                tmVoucherList.tmEquipments = this.buildEquipment(tmVoucherList.tmEquipments, tmVoucherStatus);
                tmVoucherList.tmMaterials = this.buildMaterial(tmVoucherList.tmMaterials, tmVoucherStatus);
                tmVoucherList.tmMiscellaneous = this.buildTMMiscellaneous(tmVoucherList.tmMiscellaneous, tmVoucherStatus);
                tmVoucherList.descriptionOfWork = tmVoucherList.descriptionOfWork ?? "";
                tmVoucherList.approvedBy = tmVoucherList.approvedBy ?? "";
                tmVoucherList.tmVoucherSignature = this.emptyAttachment();

                if (tmVoucherList.tmAttachments?.length > 0) {
                    const signatureAttachment = tmVoucherList.tmAttachments.find(a => a.attachmentName === Constants.TM_VOUCHER_SIGNATURE_DISCRIMINATOR);
                    if (signatureAttachment) {
                        tmVoucherList.tmVoucherSignature = signatureAttachment;
                        tmVoucherList.tmVoucherSignature.discriminator = Constants.TM_VOUCHER_SIGNATURE_DISCRIMINATOR;
                        tmVoucherList.tmAttachments = tmVoucherList.tmAttachments.filter(a => a.id !== signatureAttachment.id);
                        tmVoucherList.hasSignature = true;
                    }
                }

                this.setState({ tmVoucherList, initialTMVoucherList: cloneDeep(tmVoucherList), isAllowTMVoucherSignature: tmVoucherList.isAllowTMVoucherSignature });
            }
        });
    }

    buildEquipment(equipmentList) {
        let listOfEquipment = [];
        if (equipmentList.length === 0) {
            listOfEquipment.push(this.emptyEquipment());
        } else {
            listOfEquipment = equipmentList.map(a => {
                const equipment = {
                    equipmentUnitNumber: a.equipmentUnitNumber ?? "",
                    equipmentHours: a.equipmentHours ?? "",
                    equipmentDays: a.equipmentDays ?? "",
                    equipmentDescription: a.equipmentDescription ?? "",
                    equipmentValue: !a.equipmentDescription || !a.isOther ? a.equipmentDescription ?? "" : Constants.OTHER
                };
                return { ...a, ...equipment, };
            });
        }
        return listOfEquipment;
    }

    buildMaterial(materialList) {
        let listOfMaterial = [];
        if (materialList.length === 0) {
            listOfMaterial.push(this.emptyMaterial());
        } else {
            listOfMaterial = materialList.map(a => {
                const material = {
                    materialQuantity: a.materialQuantity ?? "",
                    materialSize: a.materialSize ?? "",
                    materialDescription: a.materialDescription ?? "",
                    materialValue: !a.materialDescription || !a.isOther ? a.materialDescription ?? "" : Constants.OTHER
                };
                return { ...a, ...material };
            });
        }
        return listOfMaterial;
    }

    buildTMMiscellaneous(tmMiscellaneousList) {
        let listOfTMMiscellaneous = [];
        if (tmMiscellaneousList.length === 0) {
            listOfTMMiscellaneous.push(this.emptyTMMiscellaneous());
        } else {
            listOfTMMiscellaneous = tmMiscellaneousList.map(a => {
                const miscellaneous = {
                    miscType: a.miscType ?? "",
                    miscDescription: a.miscDescription ?? "",
                }
                return { ...a, ...miscellaneous };
            });
        }
        return listOfTMMiscellaneous;
    }

    onClickSaveTMVoucher(isFromConfirmation = false) {
        const { tmVoucherList, initialTMVoucherList, selectedDate, selectedTMVoucher, isAllowTMVoucherSignature } = this.state;
        if (isAllowTMVoucherSignature && this.isSignatureEmpty()) {
            this.setState({ isShowTMVoucherSignatureValidation: true });
            return;
        }
        this.setState({ isSaveButtonDisabled: true, isShowLoader: true }, () => {
            const defaultObj = {
                deviceId: this.props.device.deviceId,
                deviceName: this.props.user.deviceEmpID,
                submittedDeviceId: this.props.device.deviceId,
                submittedDeviceName: this.props.user.deviceEmpID,
                createdDate: new Date(selectedDate),
                creationDate: new Date(),
                createdDateTime: new Date(),
                isIncludeSync: true
            };
            const defaultObjOnlyTmVoucher = {
                deviceId: this.props.device.deviceId,
                deviceName: this.props.user.deviceEmpID,
                submittedDeviceId: this.props.device.deviceId,
                submittedDeviceName: this.props.user.deviceEmpID,
                creationDate: new Date(),
                createdDateTime: new Date(),
                isIncludeSync: true
            };
            if (isEqual(tmVoucherList, initialTMVoucherList) && !this.isSignatureExist()) {
                const isTMVoucherAlreadySaved = tmVoucherList.status !== Constants.IN_PROGRESS;
                this.props.history.push("/TMVoucherPDFViewer", { selectedTMVoucher, isFromDataEntry: true, isProjectUnAssigned: this.state.isProjectUnAssigned, isTMVoucherAlreadySaved: isTMVoucherAlreadySaved });
                return;
            } else {
                let data = cloneDeep(tmVoucherList);
                if (data.status !== Constants.IN_PROGRESS) {
                    data.id = 0;
                    data.tmVersion = data.tmVersion + 1;
                }
                data.projectId = selectedTMVoucher.projectId;
                data.projectNumber = selectedTMVoucher.projectNumber;
                data.projectName = selectedTMVoucher.projectName;
                data.taskCodeID = selectedTMVoucher.taskCodeID;
                data.taskNumber = selectedTMVoucher.taskNumber;
                data.taskName = selectedTMVoucher.taskName;
                data.descriptionOfWork = data.descriptionOfWork.trim();
                data.approvedBy = data.approvedBy.trim();
                data.syncedDateTime = new Date();
                data.tmEquipments = this.updateOrCreateEquipment(data.tmEquipments, defaultObj, data.status);
                data.tmMaterials = this.updateOrCreateMaterial(data.tmMaterials, defaultObj, data.status);
                data.tmAttachments = this.updateOrCreateAttachment(data.tmAttachments, defaultObj, data.status);
                data.tmMiscellaneous = this.updateOrCreateTMMiscellaneous(data.tmMiscellaneous, defaultObj, data.status);
                data.tmEmployees = data.tmEmployees.map(a => {
                    a.id = data.status === Constants.IN_PROGRESS ? a.id : 0;
                    return { ...a, ...defaultObj };
                });
                this.addTMVoucherSignature(data, defaultObj);

                data.status = Constants.IN_PROGRESS;
                data.submittedMode = Constants.MANUAL_SUBMITTED_MODE;
                data = { ...data, ...defaultObjOnlyTmVoucher };

                const url = `${ApiUrls.Routes.TM_VCHR_C}${ApiUrls.Routes.SV_TM_VCHR_M}`;
                const tmVoucherReport = {
                    tmVoucherList: [data],
                };
                Api.Post(url, tmVoucherReport, this).then((response) => {
                    if (response.success) {
                        if (response.data) {
                            if (isFromConfirmation) {
                                this.props.history.push("/TimeCard", { isOpenSelectTaskCode: true });
                            } else {
                                this.props.selectedTMVoucherData(response.data);
                                this.setState({ isShowLoader: false });
                                this.props.history.push("/TMVoucherPDFViewer", { selectedTMVoucher: response.data, isFromDataEntry: true, isProjectUnAssigned: this.state.isProjectUnAssigned, isTMVoucherAlreadySaved: false });
                            }
                        }
                    } else {
                        this.setState({ isSaveButtonDisabled: false, isShowLoader: false });
                        MessageBox(response.message, Constants.ERROR);
                    }
                });
            }
        });
    }

    createTMVoucherSignature(defaultObj) {
        const { signatureRef, tmVoucherList } = this.state;

        const isEmpty = this.isSignatureEmpty();
        if (isEmpty) {
            if (tmVoucherList.tmVoucherSignature.id === 0) {
                return null
            }

            tmVoucherList.tmVoucherSignature.isActive = false;
            return tmVoucherList.tmVoucherSignature;
        }

        const attachmentContent = signatureRef.current?.toDataURL(Constants.PNG_IMAGE_FORMAT);
        // const attachmentContent = signatureRef.current?.getTrimmedCanvas()?.toDataURL(Constants.PNG_IMAGE_FORMAT);
        if (!isEmpty && attachmentContent) {
            let attachment = this.emptyAttachment();
            attachment.id = tmVoucherList.tmVoucherSignature.id > 0 ? tmVoucherList.tmVoucherSignature.id : 0;
            attachment.attachmentName = Constants.TM_VOUCHER_SIGNATURE_DISCRIMINATOR;
            attachment.attachmentType = Constants.PNG_IMAGE_FORMAT;
            attachment.attachmentContent = attachmentContent.split(',')[1];
            attachment.isActive = true;
            attachment = { ...attachment, ...defaultObj }
            return attachment;
        }
        return null;
    }

    addTMVoucherSignature(data, defaultObj) {
        const signatureAttachment = this.createTMVoucherSignature(defaultObj);
        data.hasSignature = false;
        if (signatureAttachment) {
            signatureAttachment.id = data.status === Constants.IN_PROGRESS ? signatureAttachment.id : 0;
            data.tmAttachments.push(signatureAttachment);
            if (signatureAttachment.isActive) {
                data.hasSignature = true;
            }
        }
    }

    updateOrCreateEquipment(tmEquipments, defaultObj, tmVoucherStatus) {
        const equipmentList = [];
        for (let equipment of tmEquipments) {
            equipment.id = tmVoucherStatus === Constants.IN_PROGRESS ? equipment.id : 0;
            const equipmentDays = equipment.equipmentDays.trim() ?? "";
            const equipmentHours = equipment.equipmentHours.trim() ?? "";
            const equipmentUnitNumber = equipment.equipmentUnitNumber.trim() ?? "";
            const equipmentDescription = equipment.equipmentDescription.trim() ?? "";
            equipment.equipmentDays = utility.hoursFormation(equipmentDays);
            equipment.equipmentHours = utility.hoursFormation(equipmentHours);
            equipment.equipmentUnitNumber = equipmentUnitNumber;
            equipment.equipmentDescription = equipmentDescription;
            if (!equipment.isDeleted) {
                equipment.isDeleted = equipmentDays === "" && equipmentHours === "" && equipmentUnitNumber === "" && equipmentDescription === "";
            }
            equipment = { ...equipment, ...defaultObj }
            if (equipment.id > 0) {
                equipment.lastUpdatedDate = new Date();
                equipmentList.push(equipment);
            } else if (!equipment.isDeleted) {
                equipmentList.push(equipment)
            }
        }
        return equipmentList;
    }

    updateOrCreateMaterial(tmMaterials, defaultObj, tmVoucherStatus) {
        const materialList = []
        for (let material of tmMaterials) {
            material.id = tmVoucherStatus === Constants.IN_PROGRESS ? material.id : 0;
            const materialQuantity = material.materialQuantity.trim() ?? "";
            const materialDescription = material.materialDescription.trim() ?? "";
            const materialSize = material.materialSize.trim() ?? "";
            material.materialQuantity = utility.hoursFormation(materialQuantity);
            material.materialDescription = materialDescription;
            material.materialSize = materialSize;
            if (!material.isDeleted) {
                material.isDeleted = materialDescription === "" && materialQuantity === "" && materialSize === "";
            }
            material = { ...material, ...defaultObj }
            if (material.id > 0) {
                material.lastUpdatedDate = new Date();
                materialList.push(material);
            } else if (!material.isDeleted) {
                materialList.push(material)
            }
        }
        return materialList;
    }

    updateOrCreateTMMiscellaneous(tmMiscellaneous, defaultObj, tmVoucherStatus) {
        const tmMiscellaneousList = [];
        for (let miscellaneous of tmMiscellaneous) {
            miscellaneous.id = tmVoucherStatus === Constants.IN_PROGRESS ? miscellaneous.id : 0;
            const miscType = miscellaneous.miscType.trim() ?? "";
            const miscDescription = miscellaneous.miscDescription.trim() ?? "";
            if (!miscellaneous.isDeleted) {
                miscellaneous.isDeleted = miscType === "" && miscDescription === "";
            }
            miscellaneous = { ...miscellaneous, ...defaultObj };
            if (miscellaneous.id > 0) {
                miscellaneous.lastUpdatedDate = new Date();
                tmMiscellaneousList.push(miscellaneous);
            } else if (!miscellaneous.isDeleted) {
                tmMiscellaneousList.push(miscellaneous);
            }
        }
        return tmMiscellaneousList;
    }

    updateOrCreateAttachment(tmAttachments, defaultObj, tmVoucherStatus) {
        const attachmentList = [];
        for (let attachment of tmAttachments) {
            attachment.id = tmVoucherStatus === Constants.IN_PROGRESS ? attachment.id : 0;
            attachment = { ...attachment, ...defaultObj }
            if (attachment.id > 0) {
                attachment.lastUpdatedDate = new Date();
                attachmentList.push(attachment);
            } else if (attachment.isActive) {
                attachmentList.push(attachment)
            }
        }
        return attachmentList;
    }

    onClickBackButton() {
        const { tmVoucherList, initialTMVoucherList } = this.state;
        if (isEqual(tmVoucherList, initialTMVoucherList) && !this.isSignatureExist()) {
            this.props.selectedTMVoucherData("");
            this.props.history.push("/TimeCard", { isOpenSelectTaskCode: true });
        } else {
            this.setState({ isShowTMVoucherConfirmation: true });
        }
    }

    goOrCloseConfirmation(isSave = false) {
        this.setState({ isShowTMVoucherConfirmation: false }, () => {
            if (isSave) {
                this.onClickSaveTMVoucher(true);
            } else {
                this.props.history.push("/TimeCard", { isOpenSelectTaskCode: true });
            }
        });
    }

    onClickDelete(index, objName) {
        let { deleteConfirmationHeader, deleteConformationMessage } = this.state;
        if (objName === Constants.TM_EQUIPMENT) {
            deleteConfirmationHeader = Constants.DELETE_EQUIPMENT_HEADER;
            deleteConformationMessage = Constants.DELETE_EQUIPMENT_MESSAGE;
        } else if (objName === Constants.TM_MATERIAL) {
            deleteConfirmationHeader = Constants.DELETE_MATERIAL_HEADER;
            deleteConformationMessage = Constants.DELETE_MATERIAL_MESSAGE;
        } else if (objName === Constants.TM_MISCELLANEOUS) {
            deleteConfirmationHeader = Constants.DELETE_TM_MISCELLANEOUS_HEADER;
            deleteConformationMessage = Constants.DELETE_TM_MISCELLANEOUS_MESSAGE;
        }
        this.setState({
            isDeleteConfirmationPopupVisible: true,
            selectedIndexForDelete: index,
            selectedObjectForDelete: objName,
            deleteConfirmationHeader,
            deleteConformationMessage,
        });
    }

    onCancelDeleteConfirmation = () => {
        this.setState({
            isDeleteConfirmationPopupVisible: false,
            selectedIndexForDelete: '',
            selectedObjectForDelete: '',
        });
    }

    clearSignature() {
        const { signatureRef, tmVoucherList } = this.state;
        if (signatureRef.current) {
            signatureRef.current.clear();
        }
        tmVoucherList.hasSignature = false;
        this.setState({ tmVoucherList });
    }

    isSignatureEmpty() {
        const { signatureRef } = this.state;
        if (signatureRef.current) {
            return signatureRef.current.isEmpty();
        }
        return false;
    }

    isSignatureExist() {
        const { signatureRef } = this.state;
        const pointData = signatureRef.current?.toData();
        if (pointData.length > 0) {
            return true
        }
        return false;
    }

    closeValiationPopups() {
        this.setState({ isShowTMVoucherSignatureValidation: false });
    }

    render() {
        const { tmVoucherList, equipmentOptions, materialOptions, isShowImageViewer, selectedAttachment,
            isShowTMVoucherConfirmation, selectedTMVoucher, isSaveButtonDisabled,
            isProjectUnAssigned, isShowLoader, deleteConfirmationHeader, deleteConformationMessage,
            isDeleteConfirmationPopupVisible, signatureRef, isShowTMVoucherSignatureValidation
        } = this.state;
        return (
            <TmVoucherDataEntryComponent
                {...{
                    tmVoucherDataEntry: {
                        tmVoucherList,
                        equipmentOptions,
                        materialOptions,
                        isShowImageViewer,
                        selectedAttachment,
                        isShowTMVoucherConfirmation,
                        selectedTMVoucher,
                        isSaveButtonDisabled,
                        isProjectUnAssigned,
                        isShowLoader,
                        deleteConfirmationHeader,
                        deleteConformationMessage,
                        isDeleteConfirmationPopupVisible,
                        signatureRef,
                        isShowTMVoucherSignatureValidation
                    }
                }}
                handleInputChange={this.handleInputChange.bind(this)}
                onClickSaveTMVoucher={this.onClickSaveTMVoucher.bind(this)}
                onClickAddTmEquipment={this.onClickAddTmEquipment.bind(this)}
                onClickAddTMMaterial={this.onClickAddTMMaterial.bind(this)}
                onClickAddTMMiscellaneous={this.onClickAddTMMiscellaneous.bind(this)}
                onClickDeleteConfirmation={this.onClickDeleteConfirmation.bind(this)}
                onClickBackButton={this.onClickBackButton.bind(this)}
                selectFiles={this.selectFiles.bind(this)}
                viewOrCloseAttachment={this.viewOrCloseAttachment.bind(this)}
                removeAttachment={this.removeAttachment.bind(this)}
                goOrCloseConfirmation={this.goOrCloseConfirmation.bind(this)}
                onClickDelete={this.onClickDelete.bind(this)}
                onCancelDeleteConfirmation={this.onCancelDeleteConfirmation.bind(this)}
                clearSignature={this.clearSignature.bind(this)}
                closeValiationPopups={this.closeValiationPopups.bind(this)}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user,
        device: state.deviceReducer.device,
        date: state.dateReducer.date,
        tmVoucherReducer: state.tmVoucherReducer.selectedTMVouchers
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TmVoucherDataEntry);

TmVoucherDataEntry.displayName = "TmVoucherDataEntry";